import axios from 'axios';

export const isRequestCanceled = (error: unknown): boolean => {
  if (axios.isCancel(error)) {
    return true;
  }

  if (error instanceof DOMException && error.name === 'AbortError') {
    return true;
  }

  if (typeof error !== 'object' || error === null) {
    return false;
  }

  const code = 'code' in error ? error.code : undefined;
  const name = 'name' in error ? error.name : undefined;

  return code === 'ERR_CANCELED' || name === 'AbortError' || name === 'CanceledError';
};
